import React from 'react';
import { Link } from 'react-router';
import { isAbsoluteLegalUrl } from '../studioLinks';

type StudioHostLinkProps = {
  href: string;
  children: React.ReactNode;
  className?: string;
  testId?: string;
  onClick?: () => void;
};

/**
 * Same-host → router Link; cross-host → plain <a>.
 * Mirrors the LSC landing Terms/Privacy pattern.
 */
const StudioHostLink: React.FC<StudioHostLinkProps> = ({
  href,
  children,
  className,
  testId,
  onClick,
}) => {
  if (isAbsoluteLegalUrl(href)) {
    return (
      <a href={href} className={className} data-testid={testId} onClick={onClick}>
        {children}
      </a>
    );
  }
  return (
    <Link to={href} className={className} data-testid={testId} onClick={onClick}>
      {children}
    </Link>
  );
};

export default StudioHostLink;
